export const QUERY_REPORT_SEARCH = `query reportSearch($templateId: String, $productDescription: String, $screwLength: String, $screwDiameter: String, $screwType: String, $supplier: String, $customer: String, $dateTo: DateTime, $dateFrom: DateTime, $reportNr: String, $reportDescription: String) {
  searchReports(templateId: $templateId, productDescription: $productDescription, screwLength: $screwLength, screwDiameter: $screwDiameter, screwType: $screwType, supplier: $supplier, customer: $customer, dateTo: $dateTo, dateFrom: $dateFrom, reportNr: $reportNr, reportDescription: $reportDescription) {
    id
    name
    secret
    report_number
    customer
    customer_order_number
    shipping_date
    order_confirmation
    dataValidation
    dataProgress
    sheets {
    id
    }
  }
}`;
